<script setup>
import XuTitle from './XuTitle.vue'
import Silde from "./Slide.vue"
import RollSlide from "./RollSlide.vue"
import TableSlide from './TableSlide.vue'
// import BarChart from './BarChart.vue'
import TempMode from "./TempMode.vue"
import DoughnutChart from './DoughnutChart.vue'
import ColdRoomRunTime from './ColdRoomRunTime.vue'
import AlarmList from './AlarmList.vue'
import { ref,onMounted } from "vue";
import { ElCarousel, ElCarouselItem,ElImage } from 'element-plus'
import { useRouter } from "vue-router";
import mapImage from '../assets/map.png';
const { currentRoute } = useRouter();
const router = currentRoute.value
// import BaiduMap from './BaiduMap.vue'
let currentModel = ref(0);
const carousel = ref(null);
const token = router.query._au;
console.log(token)
const changeMode = (model) => {
  currentModel.value = model;
  carousel.value.setActiveItem(model);
}
// onMounted(() => {
//     console.log(router.query._au)
// });
</script>

<template>
  <div id="bigScreen">
    <!-- <div> -->
    <div class="header">
      <!-- <img class="logo" src="../assets/logo.jpg" alt="logo"> -->
      浦东物流中心智慧大屏
    </div>
    <div class="main-box">
      <div class="left">
        <XuTitle title="项目简介" subTitle="BRIEF INTRODUCE"></XuTitle>
        <Silde class="">
          <pre class="content">    浦东物流中心3号库新建进、出港冷库项目，位于上海市浦东新区祝桥镇航城路1279号，基于满足东方航空物流股份有限公司运营需求，在浦东物流中心3号库内新增的温控功能区的设备系统集成项目，分为进港及出港2个区域：其中进港库设计有冻结物冷藏间（0~18℃）、回笼间（2~8℃）、海关检查间（15~25℃）、冷却物冷藏间一（2~8℃/15~25℃)和冷却物冷藏间二（2~8℃）五个冷间；出港库设计有冷却物冷藏间（2~8℃/15~25℃)、站台兼安检间（15~25℃）两个冷间。</pre>
        </Silde>
        <XuTitle title="能耗组成占比" subTitle="ENERGY COMPOSITION"></XuTitle>
        <div class="flex-box flex-space-between mt-20 inventory-box">
          <DoughnutChart />
          <RollSlide></RollSlide>
        </div>
        <TableSlide></TableSlide>
        <div style="height: 260px;">
          <XuTitle title="报警列表" subTitle="ALARM LIST"></XuTitle>
          <AlarmList></AlarmList>
        </div>
      </div>
      <div class="center">
        <div class="change-map-btn-box">
          <!-- <div class="mt-10">
            <b class="colorLG title-bg fz-sm">PROJECT CONFIGURATION</b>
            <b class="ml-6 fz-sm colorWhite">项目组态</b>
          </div> -->
          <!-- <XuTitle title="项目组态" subTitle="PROJECT CONFIGURATION"></XuTitle> -->
          <ul>
            <li :class="currentModel === 0 ? 'active' : ''" @click="changeMode(0)">进港</li>
            <li :class="currentModel === 1 ? 'active' : ''" @click="changeMode(1)">出港</li>
          </ul>
          <el-carousel ref="carousel" :interval="50000" trigger="click" height="100%" style="width:100%;height:100%"
            v-model="currentModel" indicator-position="none">
            <el-carousel-item>
              <iframe
                :src="'https://middle.coolinkiot.com/#/Zutai/Ol?configId=09a507c67de94bcf9af6324b4f5566b1&systemtype=PHM_PC&_au='+token+'&theme=light'"></iframe>
            </el-carousel-item>
            <el-carousel-item>
              <iframe
                :src="'https://middle.coolinkiot.com/#/Zutai/Ol?configId=af3902d23e514d1fb5e89bcefdd9e309&systemtype=PHM_PC&_au='+token+'&theme=light'"></iframe>
            </el-carousel-item>
          </el-carousel>
        </div>
        <!-- <BarChart></BarChart> -->
        <TempMode></TempMode>
      </div>
      <div class="right">
        <!-- <XuTitle title="视频介绍" subTitle="VIDEO INTRODUCE"></XuTitle>
        <div class="video-box">
          <video src="../assets/video.mp4" muted controls autoplay loop></video>
        </div> -->
        <XuTitle title="项目地址" subTitle="PROJECT ADDRESS"></XuTitle>
        <!-- <BaiduMap></BaiduMap> -->
       <div class="video-box">
          <el-image :src="mapImage" style="width: 100%; height: 100%;"></el-image>
        </div>
        <ColdRoomRunTime></ColdRoomRunTime>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
#bigScreen {
  // width: 1920px;
  // height: 1080px;
  width: 100vw;
  height: 100vh;
  position: fixed;
  z-index: 110;
  padding: 0 20px 20px;
  left: 0;
  top: 0;
  // pointer-events: none;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

.main-box {
  display: flex;
  justify-content: space-between;
  height: calc(100% - 50px);
  margin-top: -20px;
}

.left {
  width: 400px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.right {
  width: 370px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.center {
  position: relative;
  display: flex;
  flex-direction: column;
  width: calc(100% - 760px);
  height: 100%;
  // margin: 0 20px;
}

.video-box {
  width: 100%;
  height: 260px;
  // height: 20vh;
  margin-top: 10px;
  padding: 14px 14px 10px;
  background: url("../assets/video-bg.png") no-repeat;
  background-size: 100% 100%;
  box-sizing: border-box;
  pointer-events: all;

  video {
    width: 100%;
    height: 216px;
  }
}


.content {
  position: absolute;
  width: 100%;
  white-space: pre-wrap;
  font-weight: 500;
  font-size: 14px;
}

.inventory-box {
  height: 200px;
}

.header {
  height: 70px;
  background-image: url(@/assets/title.png);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  text-align: center;
  color: rgb(240, 245, 251);
  font-size: 35px;
  font-weight: bold;
  line-height: 70px;
  // text-shadow: 0 0 10px #fff;
  letter-spacing: 5px;
  // filter: hue-rotate(5deg) brightness(4.8);
}

.logo {
  //width: 50px;
  height: 50px;
  vertical-align: middle;
}

iframe {
  width: 100%;
  height: 100%;
  border: 0;
  pointer-events: none;
}

.change-map-btn-box {
  position: relative;
  width: 100%;
  height: calc(100% - 220px);
}

.change-map-btn-box {
  ul {
    position: absolute;
    top: 20px;
    z-index: 100;
  }

  li {
    background: url("~@/assets/btn1.png") right top no-repeat;
    color: #fff;
    font-weight: bold;
    width: 140px;
    height: 48px;
    font-size: 16px;
    margin: 10px 0;
    padding: 6px 0 0 10px;
    text-align: center;
    transition: all 0.5s;
    cursor: pointer;
  }

  li.active {
    background: url("~@/assets/btn2.png") right top no-repeat;
  }
}
.table-roll-box {
    position: relative;
    margin-top: 20px;
}

.table-roll {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    // margin-left: 20px;
    overflow: hidden;
}

.table-roll li {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    position: absolute;
    left: 0;
    transition: all 2s;
    font-size: 16px;
}

.table-roll li.roll_0 {
    // opacity: 0.5;
    top: 0;
    /* font-size:10px; */
}

.table-roll li.roll_1 {
    // opacity: 0.8;
    top: 36px;
    /* font-size:14px; */
}

.table-roll li.roll_2 {
    top: 72px;
}

.table-roll li.roll_3 {
    top: 108px;
}

.table-roll li.roll_4 {
    opacity: 0;
    top: 144px;
}

.table-roll .roll_hide {
    display: none;
}

.border-roll {
    li {
        position: relative;
        height: 36px;
        width: 100%;
    }
}
</style>
